/**
 *  @class
 *  @function SlideShow
 */
if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const slideshow = this;
      const slides = Array.from(slideshow.querySelectorAll('.swiper-slide'));
      if (slides.length < 1) return;

      const dots = slideshow.dataset.dots === 'true';
      const autoplay = slideshow.dataset.autoplay === 'false' ? false : parseInt(slideshow.dataset.autoplay, 10);
      const align = slideshow.dataset.align === 'center' ? 'center' : 'left';
      const fade = slideshow.dataset.fade === 'true';
      const isMain = slideshow.classList.contains('main-slideshow');
      const adaptiveHeight = isMain && (slideshow.classList.contains('desktop-height-image') || slideshow.classList.contains('mobile-height-image'));

      const config = {
        slidesPerView: 1,
        loop: false,
        watchOverflow: true,
        centeredSlides: align === 'center',
        autoHeight: adaptiveHeight,
        allowTouchMove: true,
        navigation: {
          prevEl: slideshow.querySelector('.swiper-button-prev'),
          nextEl: slideshow.querySelector('.swiper-button-next'),
        },
        pagination: dots
          ? {
              el: slideshow.querySelector('.swiper-pagination'),
              clickable: true,
              bulletClass: 'swiper-pagination-bullet',
              bulletActiveClass: 'is-selected',
            }
          : false,
      };

      if (fade) {
        config.effect = 'fade';
        config.fadeEffect = { crossFade: true };
      }

      if (autoplay) {
        config.autoplay = {
          delay: autoplay,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        };
      }

      if (isMain) {
        config.on = {
          init: function () {
            SlideShow.applyColor(slideshow, this.slides[this.activeIndex]);
            const videoContainer = this.slides[0].querySelector('.slideshow__slide-video-bg');
            if (videoContainer) {
              const iframe = videoContainer.querySelector('iframe');
              const video = videoContainer.querySelector('video');
              const loadVideo = () => {
                if (iframe && iframe.classList.contains('lazyload')) {
                  iframe.addEventListener('lazybeforeunveil', () => {
                    slideshow.videoPlay(videoContainer);
                  });
                  if (window.lazySizes) lazySizes.loader.checkElems();
                } else if (video) {
                  slideshow.videoPlay(videoContainer);
                }
              };
              if (iframe) {
                iframe.onload = loadVideo;
              } else if (video) {
                video.onloadstart = loadVideo;
              }
            }
          },
          slideChange: function () {
            SlideShow.applyColor(slideshow, this.slides[this.activeIndex]);

            const prev = this.slides[this.previousIndex];
            if (prev) {
              const videoContainerPrev = prev.querySelector('.slideshow__slide-video-bg');
              if (videoContainerPrev) {
                slideshow.videoPause(videoContainerPrev);
              }
            }

            const current = this.slides[this.activeIndex];
            if (current) {
              const videoContainer = current.querySelector('.slideshow__slide-video-bg');
              if (videoContainer) {
                slideshow.videoPlay(videoContainer);
              }
            }
          },
        };
      }

      this.swiper = new Swiper(slideshow, config);

      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          const index = slides.indexOf(event.target);
          if (index >= 0) this.swiper.slideTo(index);
        });
      }
    }

    static applyColor(slideshow, slideEl) {
      if (!slideEl) return;
      const colorText = getComputedStyle(slideEl).getPropertyValue('--color-body');
      const wrapper = slideshow.querySelector('.carousel-navigation');
      if (wrapper) {
        wrapper.style.setProperty('--color-body', colorText);
      }
    }

    videoPause(videoContainer) {
      setTimeout(() => {
        if (videoContainer.dataset.provider === 'hosted') {
          videoContainer.querySelector('video').pause();
        } else if (videoContainer.dataset.provider === 'youtube') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "pauseVideo",
            args: ""
          }), "*");
        } else if (videoContainer.dataset.provider === 'vimeo') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "pause"
          }), "*");
        }
      }, 10);
    }

    videoPlay(videoContainer) {
      setTimeout(() => {
        if (videoContainer.dataset.provider === 'hosted') {
          videoContainer.querySelector('video').play();
        } else if (videoContainer.dataset.provider === 'youtube') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: "playVideo",
            args: ""
          }), "*");
        } else if (videoContainer.dataset.provider === 'vimeo') {
          videoContainer.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
            method: "play"
          }), "*");
        }
      }, 10);
    }
  }

  customElements.define('slide-show', SlideShow);
}
